// extracted by mini-css-extract-plugin
var _1 = "title-container__kE73W";
export { _1 as "titleContainer" }
